<mobi-ui-concierge-major
    [title]="'osm.footer.concierge.title' | translate"
    [subtitle]="'osm.footer.concierge.subtitle' | translate"
>
    <div class="md:mobi-ui-col-2/6 xl:mobi-ui-col-3/8 xs:mobi-ui-col-1/1 mobi-ui-col-1/1">
        <a
            class="mobi-ui-card-major is-clickable"
            [href]="fallback.webpage"
            [target]="fallback.webpage"
        >
            <div class="mobi-ui-text-block-major is-small">
                <mobi-ui-icon-major name="store"></mobi-ui-icon-major>
                <div class="mobi-ui-text-block-content-major">
                    <span class="mobi-ui-text-block-label-major">{{
                        'osm.footer.concierge.card.webpage.title' | translate
                    }}</span>
                    <span class="mobi-ui-text-block-content-major">
                        {{ 'osm.footer.concierge.card.webpage.body' | translate }}
                    </span>
                </div>
            </div>
        </a>
    </div>
</mobi-ui-concierge-major>
